export default __webpack_public_path__ + "static/Specific patient report-75a08be798452125029b1aededd4db21.svg";